
import { defineComponent } from 'vue'
import { createValidations } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import Dropdown from 'primevue/dropdown'
import Card from 'primevue/card'
import typeTabDescriptor from './DatasetManagementTypeCardDescriptor.json'
import ParamTable from './tables/DatasetManagementParamTable.vue'
import FileDataset from './fileDataset/DatasetManagementFileDataset.vue'
import QueryDataset from './queryDataset/DatasetManagementQueryDataset.vue'
import JavaDataset from './javaDataset/DatasetManagementJavaDataset.vue'
import ScriptDataset from './scriptDataset/DatasetManagementScriptDataset.vue'
import QbeDataset from './qbeDataset/DatasetManagementQbeDataset.vue'
import FlatDataset from './flatDataset/DatasetManagementFlatDataset.vue'
import CkanDataset from './ckanDataset/DatasetManagementCkanDataset.vue'
import RestDataset from './restDataset/DatasetManagementRestDataset.vue'
import SparqlDataset from './sparqlDataset/DatasetManagementSparqlDataset.vue'
import SolrDataset from './solrDataset/DatasetManagementSolrDataset.vue'
import PythonDataset from './pythonDataset/DatasetManagementPythonDataset.vue'
import DerivedDataset from './derivedDataset/DatasetManagementDerivedDataset.vue'

export default defineComponent({
    components: { Card, Dropdown, KnValidationMessages, ParamTable, CkanDataset, QbeDataset, RestDataset, JavaDataset, FlatDataset, SolrDataset, QueryDataset, ScriptDataset, SparqlDataset, PythonDataset, FileDataset, DerivedDataset },
    props: {
        parentValid: { type: Boolean },
        selectedDataset: { type: Object as any },
        datasetTypes: { type: Array as any },
        dataSources: { type: Array as any },
        businessModels: { type: Array as any },
        scriptTypes: { type: Array as any },
        pythonEnvironments: { type: Array as any },
        rEnvironments: { type: Array as any },
        activeTab: { type: Number as any }
    },

    emits: ['touched', 'fileUploaded', 'qbeSaved', 'queryEdited'],
    data() {
        return {
            typeTabDescriptor,
            dataset: {} as any,
            v$: useValidate() as any,
            expandParamsCard: true,
            touched: false,
            qbeVisible: false
        }
    },
    computed: {},
    created() {
        this.dataset = this.selectedDataset
    },
    watch: {
        selectedDataset() {
            this.dataset = this.selectedDataset
        }
    },
    validations() {
        const validationObject = {
            dataset: createValidations('dataset', typeTabDescriptor.validations.dataset)
        }
        return validationObject
    },
    methods: {
        handleTypeChange() {
            this.touched = true
            this.dataset.pars = []
            this.dataset.restJsonPathAttributes = []
            this.dataset.restRequestHeaders = []
            this.$emit('touched')
        },
        getAllowed() {
            return this.datasetTypes.filter((cd) => {
                if (this.selectedDataset.dsTypeCd == 'Derived' || this.selectedDataset.dsTypeCd == 'Prepared') {
                    return cd.VALUE_CD == this.selectedDataset.dsTypeCd
                } else {
                    return cd.VALUE_CD != 'Derived' && cd.VALUE_CD != 'Prepared'
                }
            })
        }
    }
})
